import { render, staticRenderFns } from "./emptybusiness.vue?vue&type=template&id=25b1b8e6&scoped=true"
import script from "./emptybusiness.vue?vue&type=script&lang=js"
export * from "./emptybusiness.vue?vue&type=script&lang=js"
import style0 from "./emptybusiness.vue?vue&type=style&index=0&id=25b1b8e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b1b8e6",
  null
  
)

export default component.exports